import React, { useState, useEffect } from "react";
import {
  Text,
  View,
  StyleSheet,
  Button,
  TouchableOpacity,
  Platform,
} from "react-native";
import { BarCodeScanner } from "expo-barcode-scanner";
import { Camera } from "expo-camera";
import { useSelector, useDispatch } from "react-redux";
import DefaultText from "../../components/text/DefaultText";
import Device from "../../models/device";
import * as deviceActions from "../../store/actions/device";
import firebase from "firebase";
import { useNavigation } from "@react-navigation/native";

const PairDeviceCameraScreen = (props) => {
  const navigation = useNavigation();
  const [hasPermission, setHasPermission] = useState(null);
  const [scanned, setScanned] = useState(false);
  const [pairing, setPairing] = useState(false);
  const dispatch = useDispatch();
  const userDevices = useSelector((state) => state.devices.myDevices);
  const socket = useSelector((state) => state.socket.io);

  let deviceNum = userDevices.length + 1;
  const userId = firebase.auth().currentUser.uid;
  const newDevice = new Device(
    deviceNum,
    userId,
    `Device ${deviceNum}`,
    {
      power: "ON",
      mode: "play",
      volume: 0.5,
      // mute: false,
      brightness: 100,
      // brightAuto: false,
      speed: "5mins",
      backgroundColor: "black",
    },
    []
  );
  useEffect(() => {
    // if (Platform.OS === "web") {
    (async () => {
      const { status } = await Camera.requestCameraPermissionsAsync();
      setHasPermission(status === "granted");
    })();
    // } else {
    //   (async () => {
    //     const { status } = await BarCodeScanner.requestPermissionsAsync();
    //     setHasPermission(status === "granted");
    //   })();
    // }
  }, []);

  const handleBarCodeScanned = ({ type, data }) => {
    setScanned(true);
    alert(`Device has been scanned!`);
    let scanedDeviceId = data;
    if (scanedDeviceId.startsWith("https")) {
      scanedDeviceId = scanedDeviceId.split("=").pop();
    }
    console.log("NEW QR:", scanedDeviceId);
    newDevice.deviceId = scanedDeviceId;
    socket.emit("PAIR", { command: "PAIR REQUEST", deviceId: scanedDeviceId });
    setPairing(true);
    socket.on("PAIR", (msg) => {
      console.log("IN PAIR:", msg);
      const { command, deviceId: rcvdDeviceId } = msg;
      if (command === "PAIR ACK" && rcvdDeviceId == scanedDeviceId) {
        setPairing(false);
        dispatch(deviceActions.pairDevice(newDevice));
        socket.off("PAIR");
        navigation.navigate("DeviceScreen");
      }
    });
  };

  if (hasPermission === null) {
    return (
      <View style={styles.screen}>
        <DefaultText>Requesting for camera permission</DefaultText>
      </View>
    );
  }
  if (hasPermission === false) {
    return (
      <View style={styles.screen}>
        <DefaultText>No access to camera</DefaultText>
        <DefaultText>
          Please go to settings and grant camera permission to continue
        </DefaultText>
      </View>
    );
  }

  return (
    <View style={styles.screen}>
      {/* <BarCodeScanner
        onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
        // style={StyleSheet.absoluteFillObject}
        style={styles.camera}
      /> */}
      <Camera
        onBarCodeScanned={scanned ? undefined : handleBarCodeScanned}
        style={styles.camera}
        barCodeScannerSettings={{
          barCodeTypes: [BarCodeScanner.Constants.BarCodeType.qr],
        }}
      />
      {/* <Camera
        onBarCodeScanned={(...args) => {
          const data = args[0].data;
          result = JSON.stringify(result);
          console.log(result);
        }}
        barCodeScannerSettings={{
          barCodeTypes: ["qr"],
        }}
        style={styles.camera}
      /> */}
      {scanned && (
        <Button title={"Tap to Scan Again"} onPress={() => setScanned(false)} />
      )}
      <View style={styles.textContainer}>
        <DefaultText style={{ fontSize: 16 }}>
          Scan the QR Code from the frame{" "}
        </DefaultText>
      </View>
      {/* <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => {
          dispatch(deviceActions.pairDevice(newDevice));
          props.navigation.navigate("DeviceScreen");
        }}
      >
        <Text style={styles.pairText}>Pair Device</Text>
      </TouchableOpacity> */}
      {/* </View> */}
    </View>
  );
};

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: "black",
    alignItems: "center",
    justifyContent: "center",
  },
  camera: {
    width: "100%",
    height: "70%",
  },
  textContainer: {
    margin: 10,
    padding: 5,
  },
  buttonContainer: {
    backgroundColor: "white",
    width: "90%",
    height: 48,
    alignItems: "center",
    justifyContent: "center",
    margin: 50,
  },
});

export default PairDeviceCameraScreen;
